{
  "$id": "urn:dm:schemas:common.json",
  "color": {
    "type": "string",
    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
  },
  "nullableColor": {
    "type": [
      "string",
      "null"
    ],
    "pattern": "^(^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$)$"
  },
  "hexColor": {
    "type": "string",
    "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$"
  },
  "nullableHexColor": {
    "type": [
      "string",
      "null"
    ],
    "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$"
  },
  "numeric": {
    "type": "string",
    "pattern": "^\\d+$"
  },
  "uri": {
    "type": "string",
    "pattern": "[-a-zA-Z0-9@:%_\\+.~#?&//=]{2,256}\\.[a-z]{2,4}\\b(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?"
  },
  "border": {
    "type": "string",
    "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
  },
  "nullableBorder": {
    "type": [
      "string",
      "null"
    ],
    "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
  },
  "padding": {
    "type": "string",
    "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
  },
  "radius": {
    "type": "string",
    "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
  },
  "webThemeUrl": {
    "type": "string",
    "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
  },
  "themeUrl": {
    "type": "string",
    "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
  },
  "font": {
    "type": [
      "string"
    ]
  },
  "nullableFont": {
    "type": [
      "string",
      "null"
    ]
  },
  "cssMeasure": {
    "type": "string",
    "pattern": "^\\d+(.\\d+)?(em|px)?$"
  },
  "cssMeasureWithUnit": {
    "type": "string",
    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
  },
  "Int": {
    "type": "number",
    "multipleOf": 1
  },
  "NullableInt": {
    "type": [
      "number",
      "null"
    ],
    "multipleOf": 1
  },
  "JavaInt": {
    "type": "number",
    "default": 0,
    "multipleOf": 1,
    "minimum": -2147483648,
    "maximum": 2147483647
  },
  "JavaBool": {
    "type": "boolean",
    "default": false
  },
  "NullableBool": {
    "type": [
      "boolean",
      "null"
    ]
  },
  "reference": {
    "type": [
      "string"
    ],
    "pseudoType": [
      "ref"
    ],
    "_wixReference": true
  },
  "nullableReference": {
    "type": [
      "null",
      "string"
    ],
    "pseudoType": [
      "ref"
    ],
    "_wixReference": true
  },
  "weakReference": {
    "type": [
      "string"
    ],
    "pseudoType": [
      "weakRef"
    ],
    "_wixReference": true
  },
  "nullableWeakReference": {
    "type": [
      "null",
      "string"
    ],
    "pseudoType": [
      "weakRef"
    ],
    "_wixReference": true
  },
  "referenceList": {
    "type": [
      "array"
    ],
    "items": [
      {
        "type": [
          "null",
          "string"
        ],
        "pseudoType": [
          "ref"
        ]
      }
    ],
    "pseudoType": [
      "refList"
    ],
    "_wixReference": true
  },
  "nullableReferenceList": {
    "type": [
      "array",
      "null"
    ],
    "items": [
      {
        "type": [
          "null",
          "string"
        ],
        "pseudoType": [
          "ref"
        ]
      }
    ],
    "pseudoType": [
      "refList"
    ],
    "_wixReference": true
  },
  "DataNode": {
    "type": "object",
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        }
      }
    }
  },
  "PropDataNode": {
    "type": "object",
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "schemaVersion": {
            "type": [
              "string",
              "null"
            ],
            "default": "1.0"
          },
          "autoGenerated": {
            "type": [
              "boolean",
              "null"
            ]
          },
          "pageId": {
            "type": "string"
          },
          "sig": {
            "type": "string"
          }
        }
      }
    }
  }
}
